import React from "react";

import { Text } from "@performyard/py-components";

import { FormPreviewCard } from "./FormPreviewCard";
import { GeneratedContentContainer } from "./GeneratedContentContainer";

import type { FormSuggestionState } from "../types";

type FormSuggestionsContainerProps = {
	suggestionStates: FormSuggestionState[];
	onCreateForm: (suggestionId: string) => void;
	creatingFormIds?: Set<string>;
};

export const FormSuggestionsContainer: React.FC<FormSuggestionsContainerProps> = ({
	suggestionStates,
	onCreateForm,
	creatingFormIds,
}) => {
	const visibleSuggestions = suggestionStates.filter((fs) => fs.status !== "deleted");
	const allDeleted = visibleSuggestions.length === 0;

	return (
		<GeneratedContentContainer>
			{allDeleted ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested forms have been removed.
				</Text>
			) : (
				<div className="flex flex-col gap-2">
					{visibleSuggestions.map((fs) => (
						<FormPreviewCard
							key={fs.suggestion.id}
							suggestionState={fs}
							onCreateForm={() => onCreateForm(fs.suggestion.id)}
							isCreating={creatingFormIds?.has(fs.suggestion.id)}
						/>
					))}
				</div>
			)}
		</GeneratedContentContainer>
	);
};

export default FormSuggestionsContainer;
